export enum PosthogFeatureFlags {
  TWO_MONTHS_PROP = '2-month-purchase-date-prop-mar-26',
  QUOTE_PAGE_EXPERIMENT = 'quote-page-experiment-apr-26',
  // This is the feature flag for the QR code registration source that will be used for the new QR code registration source test.
  LANDING_PAGE = 'landing-page-may-2026',
  // The quote page A/B experiment runs as one flag per brand, so that each brand gets its
  // own PostHog experiment and therefore its own result.
  QUOTE_PAGE_V2_WHIRL = 'quote-page-v2-sep-2026-whirl',
  QUOTE_PAGE_V2_KHAID = 'quote-page-v2-sep-2026-khaid',
  GIFT_MESSAGE = 'gift-message-aug-nov-2026',
  CALL_US_HEADER = 'call-us-header-sep-2026',
  CALL_US_MODAL = 'call-us-modal-oct-2026',
  CHECKOUT_PAGE = 'checkout-page-sep-2026',
  MAINTENANCE_MODE = 'maintenance-mode',
}

export enum CheckoutPageVariant {
  CONTROL = 'control',
  TEST = 'test',
}

const checkoutPageVariants: string[] = Object.values(CheckoutPageVariant);

export const isCheckoutPageVariant = (value: unknown): value is CheckoutPageVariant =>
  typeof value === 'string' && checkoutPageVariants.includes(value);

export enum QuotePageVariant {
  CONTROL = 'control',
  RADIO = 'variant_2_radio',
}

const quotePageVariants: string[] = Object.values(QuotePageVariant);

export const isQuotePageVariant = (value: unknown): value is QuotePageVariant =>
  typeof value === 'string' && quotePageVariants.includes(value);

const quotePageFlagsByBrand: Record<string, PosthogFeatureFlags> = {
  WHIRL: PosthogFeatureFlags.QUOTE_PAGE_V2_WHIRL,
  KHAID: PosthogFeatureFlags.QUOTE_PAGE_V2_KHAID,
};

export const getQuotePageFlag = (brand?: string): PosthogFeatureFlags | undefined =>
  brand ? quotePageFlagsByBrand[brand] : undefined;
